import { $host } from './index';

export const getFeatures = async () => {
  const { data } = await $host.get('web/clinic/features');
  return data.features;
};
